import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import {
  List,
  Datagrid,
  TextField,
  NullableBooleanInput,
  TextInput,
  ListActions,
  FunctionField,
  BooleanField,
  SimpleList,
} from "react-admin";
import { useMediaQuery } from "@mui/material";
import { checkPermission } from "server/security/utils";
import { settings } from "app";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { MobileListRow } from "features/MobileListRow";
import SpecializationsExpanded from "./SpecializationsExpanded";
import SpecializationsMobileExpanded from "./SpecializationsMobileExpanded";

const ListTrainingBuildings = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  const filter = [
    <TextInput
      source="name"
      label="Учебна база"
      style={{ minWidth: "220px", marginTop: "1.5rem" }}
      alwaysOn
      resettable
    />,
    <NullableBooleanInput
      source="isExpired"
      label="Изтекла акредитация"
      nullLabel="Всички"
      style={{ minWidth: "220px", marginTop: "1.5rem" }}
      alwaysOn
    />,
  ];
  return (
    <List
      title="Учебни бази"
      exporter={false}
      filters={filter}
      actions={
        <ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageSpecialistsTrainingBuildings)} />
      }
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Учебна база (БГ)", value: record?.buildingNameBg }]} />
          )}
          secondaryText={record => (
            <>
              <div>
                <MobileListRow fields={[{ label: "Учебна база (EN)", value: record?.buildingNameEn }]} />
                <MobileListRow
                  fields={[
                    {
                      label: "Специалност с изтекла акредитация?",
                      value: record?.specializations?.some(item => item.isExpired) ? "Да" : "Не",
                    },
                  ]}
                />
              </div>
              <SpecializationsMobileExpanded record={record} />
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          expand={<SpecializationsExpanded />}
          expandSingle
          isRowExpandable={row => row?.specializations?.length > 0}
          sx={{
            "& .RaDatagrid-headerCell": {
              textAlign: "left",
            },
          }}
        >
          <TextField
            source="buildingNameBg"
            label="Учебна база (БГ)"
            sortable={false}
          />
          <TextField
            source="buildingNameEn"
            label="Учебна база (EN)"
            sortable={false}
          />
          <FunctionField
            label="Специалност с изтекла акредитация?"
            render={rec => (
              <BooleanField
                source="isExpired"
                record={{ isExpired: !!rec?.specializations?.some(item => item.isExpired) }}
              />
            )}
          />
        </Datagrid>
      )}
    </List>
  );
};

export default ListTrainingBuildings;
